import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewContainerRef, Input } from '@angular/core';
import { v4 as uuid4 } from "uuid"
import { AuctionDetailService } from '../../services/home-auction-detail.service';
import { Auction, AuctionType } from "@auctions/models/auction";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { environment } from '../../../../../environments/environment';
import { DistributorAuction } from '../../models/distributor-auction';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpClient } from '@angular/common/http';
import { ModalMailSenderComponent } from './modal-mail-sender/modal-mail-sender.component';
import { ModalHistoryChangeComponent } from './modal-history-change/modal-history-change.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeMainModalDetailMemberComponent } from '../home-main-modal-detail-member/home-main-modal-detail-member.component';
import { TokenStorage } from '../../../../storages/token.storage';
import { ModalSendAdjustmentComponent } from './modal-send-adjustment/modal-send-adjustment.component';
import { ModalMnnComponent } from './modal-mnn/modal-mnn.component';

import { ComponentRegistryService } from '../../services/component-registry.service';
import { LoggingService } from '../../../../services/logging.service';
import { OtherKpDetailService } from '../../../other-kp/services/other-kp-detail.service';
import { AuctionDrugItem } from '../../models/auction-drug-item';
import { forEach } from '@angular/router/src/utils/collection';


const API_SERVER = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.home.components.home-main-modal-detail";

declare var $: any;


@Component({
  selector: 'app-home-main-modal-detail',
  templateUrl: './home-main-modal-detail.component.html',
  styleUrls: ['./home-main-modal-detail.component.scss'],
})
export class HomeMainModalDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  popupHtmlContent: any = { value: "" }

  columnsAuction: any[];

  auction: Auction = new Auction();
  dtOptionsAuctions: DataTables.Settings = {};
  dataSetAuction: any;
  http: HttpClient;
  mailPopover = new Array<string>();
  detailDistributionFirst: string;
  detailDistributionSecond: string;
  spinner: NgxSpinnerService;
  bus: BusAuctionFilterService;
  private subscriptions: any[];  // Нужна хорошая типизация (RxJS Subscription)
  _type: number;
  token: TokenStorage;
  isChiefRole;
  isContainCd = false;
  isContainFm = false;
  rejected = false;
  isContainSai = false;

  hideOutFromDevelopFilter = false;

  private pendingAuctionType?: AuctionType;
  private pendingAuctionStatus?: string;

  showAuctionTypeChangeEmailDialog = false;

  pageSize = 100;
  currentpage = 1;
  first;

  // вывод поля Контракт с форматированием
  contractSumDisplay = '0,00';

  constructor(private service: AuctionDetailService,
    private _bus: BusAuctionFilterService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private _http: HttpClient,
    private _spinner: NgxSpinnerService,
    private _token: TokenStorage,
    private readonly _componentRegistry: ComponentRegistryService,
    private readonly _loggingService: LoggingService,
    private readonly _otherKpService: OtherKpDetailService) {

    this.bus = _bus;
    this.bus.currentAuction = this.auction;
    this.bus.currentAuction.KPNum = 0;
    this.bus.currentAuction.selectedKPFilter = 'КП 1';
    this.toastr.setRootViewContainerRef(vcr);
    this.http = _http;
    this.spinner = _spinner;
    this.token = _token;
  }

  defaultInit() {
    this.updateStateMailIcon();
    this.enableButtonParticiant(false);
    this._type = null;

    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    this.isChiefRole = this.token.isChiefRole();

  }

  ngOnInit(): void {
    const xid = uuid4();
    const qualName = "app.modules.home.components.home-main-modal-detail.HomeMainModalDetailComponent.ngOnInit";
    const inputParams = {};
    const description = "Инициализация карточки аукциона";

    this._loggingService.logStart(xid, qualName, inputParams, description);

    $('[data-toggle="modal"]').popover();
    this.columnsAuction = [
      { field: 'numberOfRow', header: '№', width: 40, title: 'Порядковый номер строки' },
      { field: 'aucDetailAgreementStatus', header: 'Статус', width: 104, title: 'Статус' },
      { field: 'mnnName', header: 'МНН', width: 145, title: 'МНН, как прописано в строках аукциона ИАС', min_width: 125 },
      { field: 'universalName', header: 'ТН ИАС', width: 145, title: 'Торговое наименование, как прописано в строках аукциона ИАС' },
      { field: 'soloName', header: 'ТН СолоФарм', width: 150, title: 'Наименование Солофарм' },
      { field: 'amountSolo', header: 'Кол-во', width: 100, title: 'Кол-во в упаковках СолоФарм' },
      { field: 'startMaxPrice', header: 'НМЦ', width: 70, title: 'Начальная максимальная цена' },
      { field: 'standartSoloPrice', header: 'ПЛ', width: 70, title: 'Стандартная цена прайс-листа СолоФарм' },
      { field: 'specialPrice', header: 'СП', width: 70, title: 'Специальная цена прайс-листа СолоФарм' },
      { field: 'registerCost', header: 'ГР', width: 70, title: 'Цена госреестра в руб. без НДС' },
      { field: 'recommendedPrice', header: 'РЦ', width: 70, title: 'Рекомендованная Цена' },
      { field: 'commertialPrice', header: 'КП 1', width: 70, title: 'Цена коммерческого предложения 1' },
      { field: 'commertialPrice2', header: 'КП 2', width: 70, title: 'Цена коммерческого предложения 2' },
      { field: 'kpsaI1', header: 'КП1 SAI', width: 100, title: 'КП1 SAI' },
      { field: 'kpsaI2', header: 'КП2 SAI', width: 100, title: 'КП2 SAI' },
      { field: 'margin1', header: 'Марж-ть 1, %', width: 120, title: 'Марж-ть 1, %' },
      { field: 'margin2', header: 'Марж-ть 2, %', width: 120, title: 'Марж-ть 2, %' },
      { field: 'contractPrice', header: 'ЦК', width: 60, title: 'Цена контракта' },
      { field: 'countOfContract', header: 'Кол-во ГК', width: 100, title: "Количество по госконтракту" },
      // { field: 'invoicePrice', header: 'ЦН', width: 60, title: 'Цена накладной', min_width: 50 },
      // { field: 'winnerPrice', header: 'ИАС', width: 60, title: 'Цена победителя по ИАС', min_width: 50 },
      { field: 'sumNmc', header: 'Ст НМЦ', width: 90, title: 'Стоимость по НМЦ' },
      { field: 'sumPl', header: 'Ст ПЛ', width: 90, title: 'Стоимость по ПЛ' },
      { field: 'weightPositionInPercent', header: '%', width: 50, title: '% от стоимости лота' },
      { field: 'isWinner', header: 'В...', width: 50, title: 'Гротекс выиграл' },
      { field: 'manufacturer', header: 'Производитель', width: 140, title: 'Производитель по ИАС' },
      { field: 'comment', header: 'Коммент.', width: 100, title: 'Комментарий' },
      { field: 'plannedIncreaseOfNMCCalc', header: 'План. увел. до<br>НМЦ расч.', width: 130, title: 'Плановое увеличение до НМЦ расч.' },
      { field: 'plannedIncreaseOfNMC', header: 'План. увел.<br>до НМЦ', width: 110, title: 'Плановое увеличение до НМЦ' },
      { field: 'agreedIncreaseOfNMC', header: 'Согл. увел.<br>до НМЦ', width: 110, title: 'Согласованное увеличение до НМЦ' },
      { field: 'plannedIncreaseOfCKCalc', header: 'План. увел. ЦК <br>на 30% расч.', width: 135, title: 'Плановое увеличение ЦК на 30% расч.' },
      { field: 'plannedIncreaseOfCK', header: 'План. увел.<br>ЦК на 30%', width: 110, title: 'Плановое увеличение ЦК на 30%' },
      { field: 'agreedIncreaseOfCK', header: 'Согл. увел.<br>ЦК на 30%', width: 110, title: 'Согласованное увеличение ЦК на 30%' },
      { field: 'totalCount', header: 'ИТОГО <br>кол-во', width: 110, title: 'Итоговое количество' }
    ];

    this.dtOptionsAuctions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      autoWidth: true,
      dom: 'tip',
      info: false,
      // scrollY: '730px',
    };

    this.first = (this.currentpage - 1) * this.pageSize;

    this.subscriptions = []
    // TODO: Уйти от логики неявного вызова — небизнесовые обращения к базе и утечки памяти
    this.subscriptions[0] = this.bus.currentAuctionNumber$.subscribe(auctionNumber => this.show(auctionNumber));

    // TODO: Уйти от логики неявного вызова — небизнесовые обращения к базе и утечки памяти
    this.subscriptions[1] = this.bus.currentDistributerAuction$.subscribe(
      distributerAuction => {
        console.log("Вызов анонимной функции при изменении дистрибьютора", this._type)

        this.bus.currentAuction.distributerParticipant = distributerAuction.distributerParticipant;
        this.bus.currentAuction.distributerParticipantName = distributerAuction.distributerParticipantName;

        this.bus.currentAuction.distributerParticipant2 = distributerAuction.distributerParticipant2;
        this.bus.currentAuction.distributerParticipant2Name = distributerAuction.distributerParticipant2Name;

        this.bus.currentAuction.distributerParticipantSAI1 = distributerAuction.distributerParticipantSAI1;
        this.bus.currentAuction.distributerParticipantSAI1Name = distributerAuction.distributerParticipantSAI1Name;

        this.bus.currentAuction.distributerParticipantSAI2 = distributerAuction.distributerParticipantSAI2;
        this.bus.currentAuction.distributerParticipantSAI2Name = distributerAuction.distributerParticipantSAI2Name;

        this.bus.currentAuction.distributerWinner = distributerAuction.distributerWinner;
        this.bus.currentAuction.distributerWinnerName = distributerAuction.distributerWinnerName;

        if (this._type != null) {
          this.spinner.show();
          this.changeDetail();
          this.getDetailDistribution();
          this.onCallCalculateDrugsAuction(this._type);
        }
      }
    );

    this.bus.currentContractBaseAuction$.subscribe(contractorAuction => {
      this.bus.currentAuction.primaryContract = contractorAuction.contractName;
    });

    this._componentRegistry.register(HomeMainModalDetailComponent, this);

  // [2] — Перезагрузка карточки после сохранения КП в модалке OtherKP

    this.subscriptions[2] = this._otherKpService.kpSaved$.subscribe(() => {
      if (this.bus.currentAuction?.code) {
        this.show(this.bus.currentAuction.code);
      }
    });

    this._loggingService.logFinish(xid, qualName, inputParams, description);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this._componentRegistry.unregister(HomeMainModalDetailComponent);
  }


  show(auctionNumber: string): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.show`;
    const inputParams = { "auctionNumber": auctionNumber };
    const description = "[Reactive] Отображение карточки аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (auctionNumber !== "<InitialValue>") {
        this.spinner.show();

        this.service.get(
          auctionNumber,
          auctionDetail => {
            if (auctionDetail != null) {  // Проверка, содержится ли карточка аукциона в хранилище
              setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);

              this.bus.currentAuction = auctionDetail;

              if (this.bus.currentAuction.kpNum == null) {
                this.bus.currentAuction.kpNum = 0;
              }

              this.bus.currentAuction.selectedKPFilter =
                this.bus.currentAuction.kpNum === 0 ? 'КП 1' : 'КП 2';

              this.dataSetAuction = auctionDetail.drugs;
              this.defaultInit();

              setTimeout(() => { $('#tableAuction').dataTable() }, 4000);

              const disAuc = new DistributorAuction();

              disAuc.distributerLogistic = auctionDetail.distributerLogistic;

              disAuc.distributerParticipant = auctionDetail.distributerParticipant;
              disAuc.distributerParticipant2 = auctionDetail.distributerParticipant2;
              disAuc.distributerParticipantSAI1 = auctionDetail.distributerParticipantSAI1;
              disAuc.distributerParticipantSAI2 = auctionDetail.distributerParticipantSAI2;

              disAuc.distributerParticipantName = auctionDetail.distributerParticipantName;
              disAuc.distributerParticipant2Name = auctionDetail.distributerParticipant2Name;
              disAuc.distributerParticipantSAI1Name = auctionDetail.distributerParticipantSAI1Name;
              disAuc.distributerParticipantSAI2Name = auctionDetail.distributerParticipantSAI2Name;

              disAuc.distributerWinner = auctionDetail.distributerWinner;
              disAuc.distributerWinnerName = auctionDetail.distributerWinner;

              this.bus.changeDistributerAuction(disAuc);

              this.spinner.hide()
            }
          }
        );
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  startProcessing(): void {
    switch (this._bus.currentAuction.status) {      
      case "SAI":
        this._bus.currentAuction.status = "SAI, КАМ";
        break;
    }
  }

  onExport(): void {
    const _xid = this._loggingService.generateUUID();

    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailComponent.onExport', null, 'Export started');

      if (this.auction.drugs != null) {
        const optionsCvs = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          useBom: true,
          noDownload: false,
          headers: [
            'Код аукциона',
            'Порядковый номер строки',
            'Группа СолоФарм. Загружается из ХД',
            'Код СолоФарм',
            'Наименование СФ: Наименование Солофарм',
            'МНН, как прописано в строках аукциона ИАС',
            'Торговое наименование, как прописано в строках аукциона ИАС',
            'Кол-во в упаковках СолоФарм',
            'Начальная максимальная цена',
            'Стандартная цена прайс-листа СолоФарм',
            'Минимальная цена прайс-листа СолоФарм',
            'Цена коммерческого предложения',
            'Цена контракта',
            'Цена накладной',
            'Цена победителя по ИАС',
            'Стоимость по НМЦ',
            'Стоимость по ПЛ',
            '% от стоимости лота',
            'Спецификация по ИАС',
            'Производитель по ИАС',
            'Комментарий'
          ]
        };

        const n = new Angular5Csv(this.auction.drugs, 'Drugs', optionsCvs);
      }

      this._loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailComponent.onExport', null, 'Export completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainModalDetailComponent.onExport', _error, null, 'Export failed');
      throw _error;
    }
  }

  mailHistory() {
    this.mailPopover[0] = this.mailPopover[1] = this.mailPopover[2] = "Загрузка истории...";
    if (this.bus.currentAuction.code != null) {
      this.http.get<Array<string>>(API_SERVER + "/commercial_offer/history/" + this.bus.currentAuction.code)
        .subscribe(resp => {
          this.mailPopover = resp;
        });
    }
  }

  getDetailDistribution() {
    this.detailDistributionFirst = this.detailDistributionSecond = "Загрузка алгоритма...";
    if (this.bus.currentAuction.distributerParticipantName != null && this.bus.currentAuction.distributerParticipantName.length > 0) {
      this.http.get<any>(API_SERVER + "/auction/detailDistribution/" + this.bus.currentAuction.distributerParticipantName)
        .subscribe(resp => {
          if (resp != null && resp.mainInfo) {
            this.detailDistributionFirst = resp.mainInfo;
          } else {
            this.detailDistributionFirst = "Ошибка";
          }
        });
    }
    if (this.bus.currentAuction.distributerParticipant2Name != null && this.bus.currentAuction.distributerParticipant2Name.length > 0) {
      this.http.get<any>(API_SERVER + "/auction/detailDistribution/" + this.bus.currentAuction.distributerParticipant2Name)
        .subscribe(resp => {
          if (resp != null && resp.mainInfo) {
            this.detailDistributionSecond = resp.mainInfo;
          } else {
            this.detailDistributionSecond = "Ошибка";
          }
        });
    }
  }


  @ViewChild(ModalMailSenderComponent)
  m: ModalMailSenderComponent;

  mailToCommercialOffer(type: number) {
    if (this.m != undefined) {
      this.m.mailToCommercialOffer(this.bus.currentAuction.code, + type, this.popupHtmlContent)
    }
  }

  @ViewChild(ModalHistoryChangeComponent)
  modalHistory: ModalHistoryChangeComponent

  historyChange() {
    if (this.modalHistory != undefined) {
      this.modalHistory.loadHistoryChange(this.bus.currentAuction.code);
    }
  }

  @ViewChild(ModalMnnComponent)
  modalMnn: ModalMnnComponent

  mnnInfo() {
    if (this.modalMnn != undefined) {
      this.modalMnn.loadMnn(this.bus.currentAuction.code);
    }
  }

  onSave() {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onSave`;
    const inputParams = {};
    const description = "[Reactive] Сохранение аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this.spinner.show();

      $(".save-btns").attr("disabled", true);

      this.service.saveAuction(this._bus.currentAuction).subscribe(
        () => {
          // TODO: Убрать после блокировки аукциона при редактировании
          this._bus.changeAuctionNumber(this._bus.currentAuction.code);

          if (!this.isContainFm && !this.isContainCd)
            if (this.rejected) {
              this.SendAdjustmentMail("rejected");
            } else {
              this.SendAdjustmentMail("confirmed");
            }

          $(".save-btns").attr("disabled", false);
          this._bus.refreshAuctionTable();
        }
      );
      this.updateStateMailIcon();

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSaveAndExit(exit: boolean): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onSaveAndExit`;
    const inputParams = { "exit": exit };
    const description = "[EventHandler] Сохранение и закрытие карточки аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this.spinner.show();
      // Eminov Rasim: Deprecated since 2026-01-20
      // $(".save-btns").attr("disabled", true);

      this.service.saveAuction(this._bus.currentAuction).subscribe(() => {
        if (!this.isContainFm && !this.isContainCd) {
          if (this.rejected) {
            this.SendAdjustmentMail("rejected");
          } else {
            this.SendAdjustmentMail("confirmed");
          }
        }

        // Eminov Rasim: Deprecated since 2026-01-20
        // $(".save-btns").attr("disabled", false);
        $("#modalAuctionDetail").modal("hide");
        this.spinner.hide();

        this._bus.refreshAuctionTable();
      });

      this.updateStateMailIcon();

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onWinnerChecked(event: any, row: AuctionDrugItem) {
    const isChecked = event?.target?.checked;
    row.isGrotexWinner = isChecked ? 1 : 0;

    this.changeDetail();
    this.onCallCalculateDrugsAuction(3, undefined);
  }

  /**
 * Сохраняет текущую позицию скролла таблицы номенклатуры
 * Возвращает функцию, которую нужно вызвать после обновления данных.
 */
  private saveTableScrollPosition(): () => void {
    // Ищем скроллируемый контейнер тела таблицы внутри модалки
    const scrollBody = document.querySelector(
      '#modalAuctionDetail .ui-table-scrollable-body'
    ) as HTMLElement;

    const top = scrollBody ? scrollBody.scrollTop : 0;

    return () => {
      // Откладываем восстановление, чтобы DOM успел перерисоваться после смены [value]
      setTimeout(() => {
        const el = document.querySelector(
          '#modalAuctionDetail .ui-table-scrollable-body'
        ) as HTMLElement;

        if (el) {
          el.scrollTop = top;
        }
      });
    };
  }

  private updateStateMailIcon() {
    this.mailHistory();

    var isNeedAdjustment;
    const st = this.bus.currentAuction.aucAgreementStatus;
    if (st == "Не требует согласования" || st == "Согласовано") {
      isNeedAdjustment = false;
    } else {
      isNeedAdjustment = true;
    }



    if ((this.bus.currentAuction.distributerParticipantName != "" && this.bus.currentAuction.distributerParticipantName != undefined && !isNeedAdjustment && !this.rejected) ||
      (this.bus.currentAuction.distributerParticipant != "" && this.bus.currentAuction.distributerParticipant != undefined) && !isNeedAdjustment && !this.rejected) {
      document.getElementById("buttonMailSender1").classList.remove('text-danger');
      document.getElementById("buttonMailSender1").classList.add('text-success');
      $('#buttonMailSender1').attr("disabled", false);
    } else {
      document.getElementById("buttonMailSender1").classList.remove('text-success');
      document.getElementById("buttonMailSender1").classList.add('text-danger');
      $('#buttonMailSender1').attr("disabled", true);
    }

    if ((this.bus.currentAuction.distributerParticipant2Name != "" && this.bus.currentAuction.distributerParticipant2Name != undefined && !isNeedAdjustment && !this.rejected) ||
      (this.bus.currentAuction.distributerParticipant2 != "" && this.bus.currentAuction.distributerParticipant2 != undefined) && !isNeedAdjustment && !this.rejected) {
      document.getElementById("buttonMailSender2").classList.remove('text-danger');
      document.getElementById("buttonMailSender2").classList.add('text-success');
      $('#buttonMailSender2').attr("disabled", false);
    } else {
      document.getElementById("buttonMailSender2").classList.remove('text-success');
      document.getElementById("buttonMailSender2").classList.add('text-danger');
      $('#buttonMailSender2').attr("disabled", true);
    }

  }

  enableButtonParticiant(disabled) {
    // $('#buttonParticiant1').attr("disabled", disabled);
    // $('#buttonParticiant2').attr("disabled", disabled);
    //$('#buttonParticiant3').attr("disabled", disabled);
    //title="текст"
  }

  hideOutFromDevelop(isHide: boolean) {
    if (this.hideOutFromDevelopFilter != isHide) {
      this.hideOutFromDevelopFilter = isHide
    }
  }

  onAuctionStatusSelect(auctionStatus: string): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onAuctionStatusSelect`;
    const inputParams = { auctionStatus };
    const description = "[EventHandler] Обработка выбора статуса аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (auctionStatus !== this._bus.currentAuction.status) {
        switch (auctionStatus) {
          case "Новый":
            this.pendingAuctionType = "Regular";
            this.pendingAuctionStatus = auctionStatus;
            this.showAuctionTypeChangeEmailDialog = true;
            break;
          case "ПРОЕКТ новый":
            this.pendingAuctionType = "Project";
            this.pendingAuctionStatus = auctionStatus;
            this.showAuctionTypeChangeEmailDialog = true;
            break;
          case "Увеличение до НМЦ":
          case "Увеличение ЦК на 30%":
            this._bus.currentAuction.status = auctionStatus;
            this.recalcAllRows();
            this.changeDetail();
            break;
          default:
            this._bus.currentAuction.status = auctionStatus;
            break;
        }
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  // TODO: Добавить синхронный декоратор для логирования.
  onAutcionTypeChangeEmailDialogClose(resultingAction: "send" | "cancel"): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onAutcionTypeChangeEmailDialogClose`;
    const inputParams = { resultingAction };
    const description = "[EventHandler] Обработка закрытия модальной формы отправки письма об изменении типа аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      switch (resultingAction) {
        case "send":
          this._bus.currentAuction.type = this.pendingAuctionType;
          this._bus.currentAuction.status = this.pendingAuctionStatus;
          this.onSave();
          break;
        case "cancel":
          break;
      }

      this.pendingAuctionType = undefined;
      this.pendingAuctionStatus = undefined;
      this.showAuctionTypeChangeEmailDialog = false;

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSelectedStatusST(statusST) {
    if (this.bus.currentAuction != null) {
      this.bus.currentAuction.statusST = statusST;
      this.changeDetail();
    }
  }

  onSetCurrentRow(drug) {
    this.bus.currentAuction.drugs.forEach((item, index) => {
      item.current = item === drug;
    });
    this.changeDetail();
  }

  isShowSaiStatus() {
    if (this.isChiefRole || (this.bus.currentAuction.status != null &&
      this.bus.currentAuction.status != undefined &&
      this.bus.currentAuction.status.toLocaleLowerCase().indexOf("sai") >= 0)) {
      return true;
    } else {
      return false;
    }
  }

  isShowSaiStatusInvert() {
    if (this.isChiefRole) {
      return true;
    } else {
      if (this.bus.currentAuction.status != null && this.bus.currentAuction.status != undefined &&
        this.bus.currentAuction.status.toLocaleLowerCase().indexOf("sai") >= 0) {
        return false;
      }
      return true;
    }
  }

  @ViewChild(HomeMainModalDetailMemberComponent)
  DetailMember: HomeMainModalDetailMemberComponent;

  // TODO: Добавить LoggingWrapper, переписать логику на сервере 
  onSetDistributor(distributorType: number, autogenerate: boolean) {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onSetDistributor`;
    const inputParams = { "distributorType": distributorType, "autogenerate": autogenerate };
    const description = "[Reactive] Выбор дистрибьютора";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      // TODO: Определить назначение атрибута _type.
      this._type = distributorType;

      if (autogenerate) {
        if (distributorType == 1 || distributorType == 2) {  // Автогенерация участников аукциона
          this.spinner.show();

          // TODO: Установить обращение к API через отдельный сервис
          this._http.get<Array<string>>(`${API_SERVER}/manufacturer/${this._bus.currentAuction.code}/${distributorType}`).subscribe(
            auctionDistributors => {
              console.log(
                "Вызов анонимной функции при получении сгенерированных участников из базы данных",
                { "auctionDistributors": auctionDistributors }
              );

              if (auctionDistributors != null) {
                let modelDistributorAuction = new DistributorAuction();

                switch (distributorType) {
                  case 1:
                    modelDistributorAuction.distributerParticipant = auctionDistributors["distrID"];
                    modelDistributorAuction.distributerParticipantName = auctionDistributors["participant"];

                    break;
                  case 2:
                    modelDistributorAuction.distributerParticipant2 = auctionDistributors["distrID"];;
                    modelDistributorAuction.distributerParticipant2Name = auctionDistributors["participant"];

                    break;
                  default:
                    // Assert: Code is unreachable
                    break;
                }

                // Временно сбрасываем _type, чтобы подписка на currentDistributerAuction$ (ngOnInit) не вызывала onCallCalculateDrugsAuction/changeDetail/getDetailDistribution
                const savedType = this._type;
                this._type = null;
                this._bus.changeDistributerAuction(modelDistributorAuction);
                this._type = savedType;
              }

              this.changeDetail();
              this.getDetailDistribution();

              // 1) Первый onCallCalculateDrugsAuction — пересчёт строк с новым участником
              this.onCallCalculateDrugsAuction(distributorType, undefined, false, () => {

                
                //спиннер скрывается только когда оба запроса завершились
                let pendingOps = 2;
                const onOpComplete = () => {
                  pendingOps--;
                  if (pendingOps === 0) {
                    this.spinner.hide();
                  }
                };

                // 2) После получения ответа — повторный onCallCalculateDrugsAuction и getCalculatedHeader параллельно, уже с обновлёнными drugs в currentAuction
                this.onCallCalculateDrugsAuction(distributorType, undefined, false, onOpComplete);

                this.service.getCalculatedHeader(this.bus.currentAuction).subscribe((auction) => {
                  this.bus.currentAuction = auction;
                  this.bus.currentAuction.selectedKPFilter = auction.kpNum === 0 ? 'КП 1' : 'КП 2';
                  onOpComplete();
                }, (error) => {
                  onOpComplete();
                });
              });
            }
          );
        }
      }

      if (distributorType == 3) {
        this.DetailMember.onFieldChange();
      }

      this._bus.currentDistributorType.type = distributorType;

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  // Присвоение статуса строкам
  onCallCalculateDrugsAuctionAfterChangeСp(alterRow = undefined) {
    const _xid = this._loggingService.generateUUID();
    this._loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailComponent.onCallCalculateDrugsAuctionAfterChangeCp', null, 'Update drugs after change Cp started');
    
    this.spinner.show();
    // Два асинхронных действия выполняются параллельно (onCallCalculateDrugsAuction и getCalculatedHeader). Спиннер скрывается только когда оба завершились
    let pendingOps = 2;
    const onOpComplete = () => {
      pendingOps--;
      if (pendingOps === 0) {
        this.spinner.hide();
      }
    };


    this.service.getCalculatedHeader(this.bus.currentAuction).subscribe((auction) => {
      this.bus.currentAuction = auction;
      this.bus.currentAuction.selectedKPFilter = auction.kpNum === 0 ? 'КП 1' : 'КП 2';
      onOpComplete();
    }, (error) => {
      onOpComplete();
    });

    this.onCallCalculateDrugsAuction(3, undefined, false, onOpComplete);
  }

  /* @param manageSpinner — управлять спиннером внутри метода (false при вызове означает ручное управление спиннером, для параллельных запросов)
  *  @param onComplete — колбэк по завершении всей цепочки запросов (для спиннера)
 */
  onCallCalculateDrugsAuction(distributorType: number | null, alterRow?: string, manageSpinner = true, onComplete?: () => void): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onCallCalculateDrugsAuction`;
    const inputParams = { distributorType, alterRow };
    const description = '[Reactive] Обновление строк номенклатуры';

    this._loggingService.logStart(xid, qualName, inputParams, description);

    if (manageSpinner) { this.spinner.show(); }

    const restoreScrollPosition = this.saveTableScrollPosition();

    this.service
      .calculateDrugsAuction(this.bus.currentAuction, distributorType, alterRow)
      .subscribe({
        next: result => {
          this.bus.currentAuction.drugs = result.drugs;
          setTimeout(() => { $('[data-toggle="popover"]').popover(); }, 0);
          restoreScrollPosition();

          if (manageSpinner) { this.spinner.hide(); }
          this._loggingService.logFinish(xid, qualName, inputParams, description);
          if (onComplete) { onComplete(); }
        },
        error: err => {
          if (manageSpinner) { this.spinner.hide(); }
          this._loggingService.logError(
            xid,
            qualName,
            err,
            inputParams,
            description
          );
          if (onComplete) { onComplete(); }
        }
      });
  }

  changeDetail() {
    document.getElementById("buttonMailSender1").classList.remove('text-success');
    document.getElementById("buttonMailSender1").classList.add('text-danger');
    $('#buttonMailSender1').attr("disabled", true);
    document.getElementById("buttonMailSender2").classList.remove('text-success');
    document.getElementById("buttonMailSender2").classList.add('text-danger');
    $('#buttonMailSender2').attr("disabled", true);
    // document.getElementById("buttonMailSender3").classList.remove('text-success');
    // document.getElementById("buttonMailSender3").classList.add('text-danger');
    // $('#buttonMailSender3').attr("disabled", true);

    this.enableButtonParticiant(true);

    $("button:disabled").attr("title", "Необходимо сохранить изменения");
    $('#replacingCompetitors').attr("title", this.bus.currentAuction.idKP ? 'Необходимо продолжить работу в Другом КП №' + this.bus.currentAuction.idKP
      : this.isAucNeedAdjustment() ? 'Необходимо сначала согласовать аукцион'
        : !this.hasRowWithoutGrotexWinner() ? 'Нет номенклатуры без признака «Гротекс выиграл»'
          : null);

    this.updateNeedAdjustmentState();
    this.isAucNeedAdjustment();
    this.hasRowWithoutGrotexWinner()
  }

  updateNeedAdjustmentState() {
    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    if (this.bus.currentAuction.drugs) {
      for (let index = 0; index < this.bus.currentAuction.drugs.length; index++) {
        const element = this.bus.currentAuction.drugs[index];
        if (element.aucDetailAgreementStatus == null || element.aucDetailAgreementStatus == "") return
        const st = element.aucDetailAgreementStatus.toLowerCase();

        if (st == "согласование с кд") {
          this.isContainCd = true;
        }

        if (st == "согласование с фм") {
          this.isContainFm = true;
        }

        if (st == "отклонено") {
          this.rejected = true;
        }
      }
    }
  }


  getSelectGood(value, row) {
    const currentSubGood = row.subDrugs[value.selectedIndex];
    this.changeDetail();
    if (currentSubGood !== undefined) {
      this.mapSelectGood(row, currentSubGood);

      this.onCallCalculateDrugsAuction(3, currentSubGood.numberOfRow + currentSubGood.soloName);
    }
  }

  isLoadind: boolean = false;

  // Проверка статуса строки аукциона
  checkState(row, timeout, event) {
    if (timeout && ((48 <= event.keyCode && event.keyCode <= 57)
      || (96 <= event.keyCode && event.keyCode <= 105)
      || 110 == event.keyCode
      || event.keyCode == 191
      || event.keyCode == 188
      || event.keyCode == 8
      || event.keyCode == 46
      || event.keyCode == 16
      || event.keyCode == 17
      || event.keyCode == 18
      || event.keyCode == 190)) {
      return
    } else {
      this.isLoadind = false;
      this.onCallCalculateDrugsAuctionAfterChangeСp(row.numberOfRow + row.soloName);
      this.changeDetail();
    }

  }

  mapSelectGood(row, currentSubGood) {

    row.soloCode = currentSubGood.code;
    row.amountSolo = currentSubGood.amountSolo;
    row.startMaxPrice = currentSubGood.startMaxPrice;
    row.standartSoloPrice = currentSubGood.standartSoloPrice;
    row.minSoloPrice = currentSubGood.minSoloPrice;
    row.sumNmc = currentSubGood.sumNmc;
    row.sumPl = currentSubGood.sumPl;
    row.recommendedPriceType = "";
    row.recommendedPrice = 0;
    row.commertialPrice = 0;
    row.commertialPrice2 = 0;
    row.commertialPrice3 = 0;
    row.contractPrice = currentSubGood.contractPrice;
    row.countOfContract = currentSubGood.countOfContract;
    row.goodDetails = currentSubGood.goodDetails;
    row.specialPrice = currentSubGood.specialPrice;
    row.actualPosition = currentSubGood.actualPosition;
    row.rowColor = currentSubGood.rowColor;
    row.isIASDataError = currentSubGood.isIASDataError;
    row.aucDetailAgreementStatus = "Отсутствует";

    console.log(currentSubGood.goodDetails)
  }

  getSelectWin(row) {
    this.changeDetail();
    row.manufacturer = "ООО Гротекс";

  }

  getGoodDetailsHtml(goodDetails: any): string {
    if (!goodDetails) return '';
    return goodDetails.replace(/\r\n|\n/g, '<br/>');
  }

  ngAfterViewInit(): void {
    $('#tableAuction').dataTable();
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();
  }

  public isContainSpecialPrice(price: string): boolean {
    if (price == "888888") {
      return true;
    } else {
    }
    return false;
  }

  public textContainSpecialPrice(price): string {
    switch (price) {
      case 222222:
        return "Эксклюзив"
      case 444444:
        return "Снята с производства"
      case 555555:
        return "Временная дефектура"
      case 777777:
        return "Розничная позиция"
      case 888888:
        return "Блэк-лист"

      default:
        return "false"
    }
  }

  // Проверка необходимости согласования в строке аукциона.
  isRowNeedAdjustment(rowData) {

    if (rowData.aucDetailAgreementStatus == null || rowData.aucDetailAgreementStatus == "") return false;

    const st = rowData.aucDetailAgreementStatus.toLowerCase();

    if (this.token.isFM() && (st == "согласование с фм")) {
      return true;
    } else if (this.token.isCD() && (st == "согласование с кд" || st == "согласование с фм")) {
      return true;
    }

    return false;

  }

  hideOutOfProduction(dt, type) {
    let hideBtn = $('#hideOutOfProduction')
    let showBtn = $('#showOutOfProduction')

    if (type == 'hide') {
      showBtn.removeClass('btn-primary')
      showBtn.addClass('btn-secondary')
      hideBtn.removeClass('btn-secondary')
      hideBtn.addClass('btn-primary')
      dt.filter('false', 'isOutOfProduction', 'equals')
    } else {
      hideBtn.removeClass('btn-primary')
      hideBtn.addClass('btn-secondary')
      showBtn.removeClass('btn-secondary')
      showBtn.addClass('btn-primary')
      dt.reset()
    }
  }

  // Проверка необходимости согласования в аукционе.
  isAucNeedAdjustment() {

    this.updateNeedAdjustmentState();
    if (this.token.isCD()) {
      // if(this.isContainCd){
      //   return true;
      // }
      return false;
    }

    if (this.bus.currentAuction.drugs) {

      if (this.token.isFM() && this.isContainFm && !this.isContainCd) {
        return false;
      }
      if (this.token.isFM() && this.isContainCd) {
        return true;
      }

      if (this.isContainFm || this.isContainCd) {
        return true;
      }

    }
    return false;
  }


  setAdjustment(isAdjustment, rowData) {

    if (!rowData.aucDetailAgreementStatus) return false;

    if (isAdjustment) {
      rowData.aucDetailAgreementStatus = "Согласовано"
    } else {
      rowData.aucDetailAgreementStatus = "Отклонено"
    }

    // Eminov Rasim: Deprecated since 2026-01-21
    //
    // принудительное сохранение данных фильтра
    // this.bus.currentFilter$.subscribe(filter => {
    //   this.bus.currentStateAuctionFilter.aucAgreementStatus = filter.aucAgreementStatus
    // });

    this.changeDetail();
    //this.onSave();

    // Todo убрать?
    this.isRowNeedAdjustment(rowData);

    // Eminov Rasim: Deprecated since 2026-01-21
    //
    // принудительное сохранение данных фильтра
    // this.bus.currentFilter$.subscribe(filter => {
    //   this.bus.currentStateAuctionFilter.aucAgreementStatus = filter.aucAgreementStatus
    // });

  }


  @ViewChild(ModalSendAdjustmentComponent)
  ModalSendAdjustment: ModalSendAdjustmentComponent;

  sendAdjustment() {
    this.ModalSendAdjustment.cleannField();
  }

  SendAdjustmentMail(key) {

    switch (key) {
      case "confirm":
        // Отправка писем на согласование
        if (this.bus.currentAuction.code != null) {
          this.http.get<Array<string>>(API_SERVER + "/SendMailToConfirm/" + this.bus.currentAuction.code)
            .subscribe(resp => {
            });
        }
        break;
      case "rejected":
        // Отправка писем отклнонено
        if (this.bus.currentAuction.code != null) {
          this.http.get<Array<string>>(API_SERVER + "/SendMailToRejected/" + this.bus.currentAuction.code)
            .subscribe(resp => {
            });
        }
        break;
      case "confirmed":
        // Отправка писем согласовано
        if (this.bus.currentAuction.code != null) {
          this.http.get<Array<string>>(API_SERVER + "/SendMailToConfirmed/" + this.bus.currentAuction.code)
            .subscribe(resp => {
            });
        }
        break;

      default:
        break;
    }
  }


  onTypeKpSelected(typeKP: number) {
    this.bus.currentAuction.selectedKPFilter = typeKP === 0 ? 'КП 1' : 'КП 2';
    this.bus.currentAuction.KPNum = typeKP;
    this.recalcAllRows();
  }

  private recalcAllRows(): void {
    this.spinner.show();

    this.changeDetail();

    // Два асинхронных действия выполняются параллельно (onCallCalculateDrugsAuction и getCalculatedHeader). Спиннер скрывается только когда оба завершились
    let pendingOps = 2;
    const onOpComplete = () => {
      pendingOps--;
      if (pendingOps === 0) {
        this.spinner.hide();
      }
    };

    this.onCallCalculateDrugsAuction(3, undefined, false, onOpComplete);

    this.service.getCalculatedHeader(this.bus.currentAuction).subscribe((auction) => {
      this.bus.currentAuction = auction;
      this.bus.currentAuction.selectedKPFilter = auction.kpNum === 0 ? 'КП 1' : 'КП 2';
      onOpComplete();
    }, (error) => {
      onOpComplete();
    });
  }

  onSetZeroesToModelClick() {
    if (this._bus.currentAuction.status !== 'Увеличение до НМЦ' && this._bus.currentAuction.status !== 'Увеличение ЦК на 30%')
      return;

    this._bus.currentAuction.drugs.forEach((drug) => {
      if (this._bus.currentAuction.status === 'Увеличение до НМЦ' && drug.agreedIncreaseOfNMC === null)
        drug.agreedIncreaseOfNMC = 0;

      if (this._bus.currentAuction.status === 'Увеличение ЦК на 30%' && drug.agreedIncreaseOfCK === null)
        drug.agreedIncreaseOfCK = 0;
    })

    this.recalcAllRows();
  }

  /** Есть ли в drugs хотя бы одна строка без галочки isGrotexWinner (кнопка «Замена конкурентов» активна только в этом случае). */
  hasRowWithoutGrotexWinner(): boolean {
    const drugs = this._bus.currentAuction?.drugs;
    if (!drugs || drugs.length === 0) return false;
    return drugs.some(d => !d.isGrotexWinner);
  }

  onOtherKPClick() {
    const _xid = this._loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.HomeMainModalDetailComponent.onOtherKPClick`;
    const auctionCode = this._bus.currentAuction?.code;
    const inputParams = { auctionCode };

    try {
      this._loggingService.logStart(_xid, qualName, inputParams, 'Opening OtherKP for auction');

      this.spinner.show();
      this.service.saveAuction(this._bus.currentAuction).subscribe(() => {
        this._otherKpService.openForAuction(auctionCode, this.spinner);
        $('#modalOtherKpDetail').modal('show');

        this._loggingService.logFinish(_xid, qualName, inputParams, 'OtherKP modal opened for auction');
      });
    } catch (_error) {
      this._loggingService.logError(_xid, qualName, _error, inputParams, 'Failed to open OtherKP for auction');
      throw _error;
    }
  }


//Проверяет, что статус текущего аукциона совпадает с переданным (для )
  public isAccordingStatus(status: string): boolean {
    return this._bus.currentAuction.status === status;
  }


  onChangeManufacturerClick(drug: any): void {
    if (!drug) return;
    this.changeDetail();

    drug.isGrotexWinner = null;

    this.onCallCalculateDrugsAuction(3, undefined);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/home-main-modal-detail.component.ts